import { render, staticRenderFns } from "./Staff1.vue?vue&type=template&id=5295e927&scoped=true&"
import script from "./Staff1.vue?vue&type=script&lang=js&"
export * from "./Staff1.vue?vue&type=script&lang=js&"
import style0 from "./Staff1.vue?vue&type=style&index=0&id=5295e927&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5295e927",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/01-qym-hop-newmall-frontend-k8s@3/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5295e927')) {
      api.createRecord('5295e927', component.options)
    } else {
      api.reload('5295e927', component.options)
    }
    module.hot.accept("./Staff1.vue?vue&type=template&id=5295e927&scoped=true&", function () {
      api.rerender('5295e927', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/Staff1.vue"
export default component.exports